import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import {
  IAccountant,
  IGetListRequest,
  IResponse,
  IServerError,
} from "../models";
import {
  IAccountantListPayload,
  IAccountantResponse,
} from "../models/accountant";
import { format422Errors, useNavigateToLogout } from "../common/Common";

import { GridSize } from "@mui/material";
import { IClientListPayload } from "../models/client";
import { IDropDownListResponse } from "../models/common/IDropDownListResponse";
import { INITIAL_PAGE_SIZE } from "../common/constants";
import http from "../common/http-commons";

// import { IFixedAndMetaField } from "common/FlexFieldsUtils";

// import {
//   ACCOUNTANT_SETUP_FORM,
//   ACCOUNTANT_SETUP_FORM_WITH_NULL_DEFAULT_VALUES,
// } from "screensLayoutData/accountant";

// import { NavigateToLogout } from "../common/Common";

// import { useNavigate } from 'react-router-dom';

// export const NavigateToLogout = (path: string): void => {
//     const navigate = useNavigate();

//     navigate(path);
// };
// export let newData: IAccountantListPayload;

export const AccountantService = {
  getAccountants: async (
    data: IGetListRequest,
    isAdminUser: any,
  ): Promise<
    IAccountantListPayload | IServerError | IResponse | IAccountantResponse[]
  > => {
    if (isAdminUser !== 400) {
      try {
        const response: AxiosResponse<IAccountantListPayload> =
          await http.get<IAccountantListPayload>(
            "/v1/accountants/for_user_wise_only?order_by=" +
              data.order_by +
              "&order_direction=" +
              data.order_direction +
              "&page=" +
              data.page +
              "&size=" +
              data.size +
              "&search_query=" +
              data.search_query,
          );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 400) {
          return {
            status: false,
            message: "Bad Request.",
            error: true,
          };
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        return { status: false, message: errorMessage, error: true };
      }
    } else {
      try {
        const response: AxiosResponse<IAccountantListPayload> =
          await http.get<IAccountantListPayload>(
            "/v1/accountants/?order_by=" +
              data.order_by +
              "&order_direction=" +
              data.order_direction +
              "&page=" +
              data.page +
              "&size=" +
              data.size +
              "&search_query=" +
              data.search_query,
          );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 400) {
          return {
            status: false,
            message: "Bad Request.",
            error: true,
          };
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        return { status: false, message: errorMessage, error: true };
      }
    }
    // const fixedResponse: any = {
    // 	page: 1,
    // 	size: 50,
    // 	total: 1,
    // 	items: [
    // 		{
    // 			id: "0b6cec0e-0987-445a-b291-5a4d61ec0093",
    // 			firstName: "Allan",
    // 			lastName: "Fefergrad",
    // 			fullName: "Allan Fefergrad",
    // 			accTitle: "AF Accounting",
    // 			email: "AfAccounting@gmail.com",
    // 			province: "Alberta",
    // 			city: "Toronto",
    // 			country: "CAN",
    // 			postalCode: "A5D5D5",
    // 			phoneNo: "(123) 456-7890",
    // 			ext: "123",
    // 			website: "11",
    // 			status: "Active",
    // 		},
    // 		{
    // 			id: "504d04da-25bd-4193-8f4c-a7b296b296bb",
    // 			firstName: "Brent",
    // 			lastName: "Miller",
    // 			fullName: "Brent Miller",
    // 			accTitle: "ALTAML Inc.",
    // 			email: "ALTAMLInc@gmail.com",
    // 			province: "Alberta",
    // 			city: "Toronto",
    // 			country: "CAN",
    // 			postalCode: "A5D5D5",
    // 			phoneNo: "(123) 456-0000",
    // 			ext: null,
    // 			website: "",
    // 			status: "Active",
    // 		},
    // 		{
    // 			id: "a14f3906-9e69-4a9f-bcc7-e1944b255a28",
    // 			firstName: "Jose A",
    // 			lastName: "Rodriguez",
    // 			fullName: "Jose A Rodriguez",
    // 			accTitle: "All Work Jobs Inc",
    // 			email: "AllWorkJobsInc@gmail.com",
    // 			province: "Alberta",
    // 			city: "Toronto",
    // 			country: "CAN",
    // 			postalCode: "A5D5D5",
    // 			phoneNo: "(123) 000-0000",
    // 			ext: null,
    // 			website: "",
    // 			status: "Active",
    // 		},
    // 		{
    // 			id: "55d127fe-26e4-4c8d-8144-62c06a872d41",
    // 			firstName: "Boris",
    // 			lastName: "Baranov",
    // 			fullName: "Boris Baranov",
    // 			accTitle: "Baranov CPA Professional Corporation",
    // 			email: "BaranovCPA@gmail.com",
    // 			province: "Alberta",
    // 			city: "Toronto",
    // 			country: "CAN",
    // 			postalCode: "A5D5D5",
    // 			phoneNo: "(999) 999-9999",
    // 			ext: null,
    // 			website: "",
    // 			status: "Active",
    // 		},
    // 		{
    // 			id: "705f5509-a2c5-4505-ada7-b94f45b10646",
    // 			firstName: "BEN",
    // 			lastName: "SAGAR",
    // 			fullName: "BEN SAGAR",
    // 			accTitle: "CANAMEX INC.",
    // 			email: "canamexInc.@hotmail.com",
    // 			province: "Alberta",
    // 			city: "Toronto",
    // 			country: "CAN",
    // 			postalCode: "A1A1A1",
    // 			phoneNo: "(123) 456-7890",
    // 			ext: null,
    // 			website: "test.com",
    // 			status: "Active",
    // 		},
    // 		{
    // 			id: "8fe63e30-b098-410d-9981-df56e7835aa4",
    // 			firstName: "Farooq",
    // 			lastName: "Khalid",
    // 			fullName: "Farooq Khalid",
    // 			accTitle: "Decent Accounting",
    // 			email: "DecentAccounting@hotmail.com",
    // 			province: "Alberta",
    // 			city: "Toranto",
    // 			country: "CAN",
    // 			postalCode: "A4A4A4",
    // 			phoneNo: "(123) 456-7777",
    // 			ext: null,
    // 			website: "",
    // 			status: "Active",
    // 		},
    // 		{
    // 			id: "3496271c-fee0-4591-9c18-1edcaad40ec5",
    // 			firstName: "Fabien",
    // 			lastName: "Gendron",
    // 			fullName: "Fabien Gendron",
    // 			accTitle: "Duncan & Co CPAse",
    // 			email: "DuncanCPAse@gmail.com",
    // 			province: "Alberta",
    // 			city: "Toronto",
    // 			country: "CAN",
    // 			postalCode: "A5D5D5",
    // 			phoneNo: "(123) 456-8888",
    // 			ext: null,
    // 			website: "",
    // 			status: "Active",
    // 		},
    // 		{
    // 			id: "288f7ee8-fdc0-4d26-a1ff-a5dfd04ea85d",
    // 			firstName: "Direct",
    // 			lastName: "Clients",
    // 			fullName: "Direct Clients",
    // 			accTitle: "Websential Inc.",
    // 			email: "WebsentialInc@gmail.com",
    // 			province: "Alberta",
    // 			city: "Toronto",
    // 			country: "CAN",
    // 			postalCode: "A5D5D5",
    // 			phoneNo: "(123) 145-3030",
    // 			ext: null,
    // 			website: "",
    // 			status: "Active",
    // 		},
    // 	],
    // 	keyField: {
    // 		field: "name",
    // 		templateUrl: "/t4-slips/{id}",
    // 	},
    // 	headerColumns: [
    // 		{
    // 			field: "fullName",
    // 			headerName: "Name",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "text",
    // 			align: "left",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			sequence: 0,
    // 			frozenColumn: true,
    // 			footer: null,
    // 			minWidth: 100,
    // 			alignFrozen: null,
    // 		},
    // 		{
    // 			field: "accTitle",
    // 			headerName: "Account Title",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "text",
    // 			align: "left",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			sequence: 1,
    // 			frozenColumn: false,
    // 			footer: null,
    // 			minWidth: 60,
    // 			alignFrozen: null,
    // 		},
    // 		{
    // 			field: "email",
    // 			headerName: "Email",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "left",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			sequence: 2,
    // 			frozenColumn: false,
    // 			footer: null,
    // 		},
    // 		{
    // 			field: "phoneNo",
    // 			headerName: "Phone",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "left",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			sequence: 3,
    // 			frozenColumn: false,
    // 			footer: null,
    // 		},
    // 		{
    // 			field: "city",
    // 			headerName: "City",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "left",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			sequence: 4,
    // 			frozenColumn: false,
    // 			footer: null,
    // 		},
    // 		{
    // 			field: "status",
    // 			headerName: "Status",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "left",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			sequence: 5,
    // 			frozenColumn: false,
    // 			footer: null,
    // 		},
    // 	],
    // };

    // return new Promise((resolve) =>
    // 	setTimeout(() => resolve(fixedResponse), 1000)
    // );
  },

  deleteById: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | null> => {
    if (!delPayload.accountantId) return null;
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/accountants/${delPayload.accountantId}/`,
      );

      if (response.status === 204) {
        return {
          status: true,
          message: "Accountant has been deleted successfully",
        };
      } else if (response.status === 200) {
        return {
          status: true,
          message: "Accountant has been deleted successfully",
        };
      } else if (response.status === 404) {
        return response.data;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  deleteAccountantBankById: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | null> => {
    if (!delPayload.accountantId) return null;
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/accountant-bank/${delPayload.accountantId}/`,
      );

      if (response.status === 204) {
        return {
          status: true,
          message: "Accountant has been deleted successfully",
        };
      } else if (response.status === 200) {
        return {
          status: true,
          message: "Accountant has been deleted successfully",
        };
      } else if (response.status === 404) {
        return response.data;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  // delAccountants: async (
  //   accountantId: string
  //   // data: IGetListRequest
  // ): Promise<
  //   IAccountantListPayload | IServerError | IResponse | IAccountantResponse[]
  // > => {
  //   const response: AxiosResponse<IAccountantListPayload> =
  //     await http.delete<IAccountantListPayload>(
  //       "/v1/accountants/" + accountantId + "/"
  //     );
  //   const responseNewList: AxiosResponse<IAccountantListPayload> =
  //     await http.get<IAccountantListPayload>(
  //       "/v1/accountants/"
  //       // +
  //       //   data.order_by +
  //       //   "&order_direction=" +
  //       //   data.order_direction +
  //       //   "&page=" +
  //       //   data.page +
  //       //   "&size=" +
  //       //   data.size +
  //       //   "&search_query=" +
  //       //   data.search_query
  //     );

  //   if (response.status === 204) {
  //     for (var i = 0; i < responseNewList.data.items.length; i++) {
  //       const record = responseNewList.data.items[i];
  //       responseNewList.data.items[i].name =
  //         record.firstName + " " + record.lastName;
  //       responseNewList.data.items[i].city = record.address?.city;
  //       record.metaFields?.map(
  //         (field: { name: string | number; value: any }) => {
  //           responseNewList.data.items[i][field.name] = field.value;
  //         }
  //       );
  //     }

  //
  //     //       newData = response.data
  //

  //     return response.data;
  //   } else if (response.status === 400) {
  //     return {
  //       status: false,
  //       message: "Bad Request.",
  //       error: true,
  //     };
  //   } else if (response.status === 500) {
  //     return {
  //       status: false,
  //       message: "Something went wrong.",
  //       error: true,
  //     };
  //   }
  //   return {
  //     status: false,
  //     message: "Something went wrong please try again later.",
  //   };
  // },

  getClientByAccountantId: async (
    accountantId: string,
    isAdminUser: number,
    params: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<IClientListPayload | IServerError | IResponse> => {
    if (accountantId !== "" && accountantId !== "0") {
      try {
        const response: AxiosResponse<IClientListPayload> =
          await http.get<IClientListPayload>(
            "/v1/clients/?accountant_id=" +
              accountantId +
              "&order_by=" +
              params.order_by +
              "&order_direction=" +
              params.order_direction +
              "&page=" +
              params.page +
              "&size=" +
              params.size +
              "&search_query=" +
              params.search_query,
          );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 400) {
          return {
            status: false,
            message: "Bad Request.",
            error: true,
          };
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        } else {
          return response.data;
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    } else if ((isAdminUser !== 400 && accountantId === "") || "0") {
      try {
        const response: AxiosResponse<IClientListPayload> =
          await http.get<IClientListPayload>(
            `/v1/clients/full-client-list/by_user/?search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
          );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 400) {
          return {
            status: false,
            message: "Bad Request.",
            error: true,
          };
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        } else {
          return response.data;
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    } else {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }
    // const fixedResponse: any = {
    // 	page: 1,
    // 	size: 50,
    // 	total: 1,
    // 	items: [
    // 		{
    // 			"id": "779acde7-4966-4360-bb35-94f60ce90bbc",
    // 			"clientName": "CANAMEX INC.",
    // 			"operatingName": "CANAMEX",
    // 			"email": "canamexInc.@hotmail.com",
    // 			"province": "Ontario",
    // 			"city": "Toronto",
    // 			"country": "CAN",
    // 			"postalCode": "A5S5S5",
    // 			"phone1": "2223334444",
    // 			"status": "Active"
    // 		},
    // 		{
    // 			"id": "84eb7f21-d5ad-42d1-b9b2-4af1df3faf88",
    // 			"clientName": "Decent Accounting",
    // 			"operatingName": "Decent",
    // 			"email": "DecentAccounting@hotmail.com",
    // 			"province": "Quebec",
    // 			"city": "Montreal",
    // 			"country": "CAN",
    // 			"postalCode": "W5E5R5",
    // 			"phone1": "4567892222",
    // 			"status": "Active"
    // 		},
    // 		{
    // 			"id": "96f80b18-81e7-404f-bfe8-14437871b6a1",
    // 			"clientName": "Websential Inc.",
    // 			"operatingName": "Websential",
    // 			"email": "WebsentialInc@gmail.com",
    // 			"province": "Quebec",
    // 			"city": "Montreal",
    // 			"country": "CAN",
    // 			"postalCode": "A5A6A7",
    // 			"phone1": "1234569999",
    // 			"status": "Active"
    // 		}
    // 	],
    // 	keyField: {
    // 		field: "name",
    // 		templateUrl: "/t4-slips/{id}",
    // 	},
    // 	headerColumns: [
    // 		{
    // 			"field": "clientName",
    // 			"headerName": "Client Name",
    // 			"description": "",
    // 			"flex": 1,
    // 			"hide": false,
    // 			"hideable": false,
    // 			"sortable": true,
    // 			"sortingOrder": "asc",
    // 			"resizable": false,
    // 			"type": "string",
    // 			"align": "left",
    // 			"headerAlign": "left",
    // 			"hideSortIcons": false,
    // 			"disableColumnMenu": true,
    // 			"disableReorder": true,
    // 			"disableExport": true,
    // 			"maskable": false,
    // 			"isFixed": true,
    // 			"sequence": 0,
    // 			"frozenColumn": false,
    // 			"footer": null
    // 		},
    // 		{
    // 			"field": "operatingName",
    // 			"headerName": "Operating Name",
    // 			"description": "",
    // 			"flex": 1,
    // 			"hide": false,
    // 			"hideable": false,
    // 			"sortable": false,
    // 			"sortingOrder": "asc",
    // 			"resizable": false,
    // 			"type": "string",
    // 			"align": "left",
    // 			"headerAlign": "left",
    // 			"hideSortIcons": false,
    // 			"disableColumnMenu": true,
    // 			"disableReorder": true,
    // 			"disableExport": true,
    // 			"maskable": false,
    // 			"isFixed": true,
    // 			"sequence": 1,
    // 			"frozenColumn": false,
    // 			"footer": null
    // 		},
    // 		{
    // 			"field": "email",
    // 			"headerName": "Email",
    // 			"description": "",
    // 			"flex": 1,
    // 			"hide": false,
    // 			"hideable": false,
    // 			"sortable": false,
    // 			"sortingOrder": "asc",
    // 			"resizable": false,
    // 			"type": "string",
    // 			"align": "left",
    // 			"headerAlign": "left",
    // 			"hideSortIcons": false,
    // 			"disableColumnMenu": true,
    // 			"disableReorder": true,
    // 			"disableExport": true,
    // 			"maskable": false,
    // 			"isFixed": true,
    // 			"sequence": 3,
    // 			"frozenColumn": false,
    // 			"footer": null
    // 		},
    // 		{
    // 			"field": "phone1",
    // 			"headerName": "Phone #",
    // 			"description": "",
    // 			"flex": 1,
    // 			"hide": false,
    // 			"hideable": false,
    // 			"sortable": false,
    // 			"sortingOrder": "asc",
    // 			"resizable": false,
    // 			"type": "string",
    // 			"align": "left",
    // 			"headerAlign": "left",
    // 			"hideSortIcons": false,
    // 			"disableColumnMenu": true,
    // 			"disableReorder": true,
    // 			"disableExport": true,
    // 			"maskable": false,
    // 			"isFixed": true,
    // 			"sequence": 4,
    // 			"frozenColumn": false,
    // 			"footer": null
    // 		},
    // 		{
    // 			"field": "city",
    // 			"headerName": "City",
    // 			"description": "",
    // 			"flex": 1,
    // 			"hide": false,
    // 			"hideable": false,
    // 			"sortable": false,
    // 			"sortingOrder": "asc",
    // 			"resizable": false,
    // 			"type": "string",
    // 			"align": "left",
    // 			"headerAlign": "left",
    // 			"hideSortIcons": false,
    // 			"disableColumnMenu": true,
    // 			"disableReorder": true,
    // 			"disableExport": true,
    // 			"maskable": false,
    // 			"isFixed": true,
    // 			"sequence": 5,
    // 			"frozenColumn": false,
    // 			"footer": null
    // 		},
    // 		{
    // 			"field": "status",
    // 			"headerName": "Status",
    // 			"description": "",
    // 			"flex": 1,
    // 			"hide": false,
    // 			"hideable": false,
    // 			"sortable": false,
    // 			"sortingOrder": "asc",
    // 			"resizable": false,
    // 			"type": "string",
    // 			"align": "left",
    // 			"headerAlign": "left",
    // 			"hideSortIcons": false,
    // 			"disableColumnMenu": true,
    // 			"disableReorder": true,
    // 			"disableExport": true,
    // 			"maskable": false,
    // 			"isFixed": true,
    // 			"sequence": 6,
    // 			"frozenColumn": false,
    // 			"footer": null
    // 		}
    // 	],
    // };

    // return new Promise((resolve) =>
    // 	setTimeout(() => resolve(fixedResponse), 1000)
    // );
  },

  getAccountantIdByClient: async (
    clientId: string,
  ): Promise<any | IServerError | IResponse> => {
    const response: AxiosResponse<any> = await http.get<any>(
      `/v1/clients/accountant-id/${clientId}/`,
    );
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 400) {
      return {
        status: false,
        message: "Bad Request.",
        error: true,
      };
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }
    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },

  delClient: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/clients/${delPayload.clientId}/`,
      );

      if (response.status === 204) {
        return {
          status: true,
          message: "Success",
        };
      } else if (response.status === 200) {
        return {
          status: true,
          message: "Success",
        };
      } else if (response.status === 404) {
        return response.data;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  delBulkClientes: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(`/v1/clients/`, {
        data: requestPayload.clientIds,
      });
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  delBulkAccountants: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(`/v1/accountants/`, {
        data: requestPayload.accountantsIds,
      });
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }

    // return {
    // 	status: false,
    // 	message: "Accountant Bulk del API not created yet.",
    // };
  },

  // getAccountantList: async (params: IGetListRequest) => {
  //
  //   const response: AxiosResponse<IAccountantListPayload> =
  //     await http.get<IAccountantListPayload>("/v1/accountants/");
  //   if (response.status === 200) {
  //     for (var i = 0; i < response.data.total; i++) {
  //       const record = response.data.items[i];
  //       response.data.items[i].name = record.firstName + " " + record.lastName;
  //       response.data.items[i].city = record.address?.city;
  //       record.metaFields?.map(
  //         (field: { name: string | number; value: any }) => {
  //           response.data.items[i][field.name] = field.value;
  //         }
  //       );
  //     }
  //     return response.data;
  //   } else if (response.status === 400) {
  //     return {
  //       status: false,
  //       message: "Bad Request.",
  //       error: true,
  //     };
  //   } else if (response.status === 500) {
  //     return {
  //       status: false,
  //       message: "Something went wrong.",
  //       error: true,
  //     };
  //   }
  //   return {
  //     status: false,
  //     message: "Something went wrong please try again later.",
  //   };
  // },
  // // getSetupLayout: async (): Promise<any> => {
  // //   let response: any = ACCOUNTANT_SETUP_FORM_WITH_NULL_DEFAULT_VALUES;
  // //   return new Promise((resolve) => setTimeout(() => resolve(response), 1000));
  // // },
  create: async (
    requestPayload: any,
  ): Promise<IAccountant | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<any> = await http.put<IAccountant>(
          requestPayload.superUser === 400
            ? `/v1/accountants/super-user/${requestPayload.id}/`
            : `/v1/accountants/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 404) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else if (axiosError && axiosError.status === 422) {
          return {
            status: false,
            message: `Errors : \n${format422Errors(
              axiosError?.response?.data,
            )}`,
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<any> = await http.post<IAccountant>(
        requestPayload.superUser === 400
          ? "/v1/accountants/super-user"
          : "/v1/accountants/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 404) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getById: async (
    id: string,
    navigateToLogout: (path: string) => void,
  ): Promise<IAccountant | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IAccountant> = await http.get<IAccountant>(
        `/v1/accountants/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  // getAccountantCategories: async (
  //   screenId: string | number
  // ): Promise<any | IServerError | IResponse> => {
  //   const response: AxiosResponse =
  //     await http.get(
  //       // '/v1/flex-fields/?search_query=category&order_by=name&order_direction=asc&page=1&size=50'
  //       `/v1/flex-fields/screen-fields?screen_name=${screenId}`
  //     );

  //   if (response.status === 200) {
  //     return response.data;
  //   } else if (response.status === 400) {
  //     return response.data;
  //   } else if (response.status === 500) {
  //     return {
  //       status: false,
  //       message: "Something went wrong.",
  //       error: true,
  //     };
  //   }
  //   return {
  //     status: false,
  //     message: "Something went wrong please try again later.",
  //   };
  // },
  // getAccountantCategoriesAssingedPanels: async (
  //   requestPayload: any
  // ): Promise<any | IServerError | IResponse> => {

  //   const response: AxiosResponse =
  //     await http.post(
  //       `/v1/flex-field-fieldsets/panel-flex-fields`,
  //       requestPayload
  //     );

  //   if (response.status === 200) {
  //     return response.data;
  //   } else if (response.status === 400) {
  //     return response.data;
  //   } else if (response.status === 500) {
  //     return {
  //       status: false,
  //       message: "Something went wrong.",
  //       error: true,
  //     };
  //   }
  //   return {
  //     status: false,
  //     message: "Something went wrong please try again later.",
  //   };
  // },
  // moveClientsByAccountantId: async (
  //   requestPayload: any
  // ): Promise<IServerError | IResponse | any> => {
  //   try {
  //     const response: AxiosResponse<IAccountant> = await http.post<IAccountant>(
  //       "/v1/clients/update-parent/",
  //       requestPayload
  //     );

  //     if (response.status === 200) {
  //       return response.data;
  //     } else if (response.status === 500) {
  //       return {
  //         status: false,
  //         message: "Something went wrong.",
  //         error: true,
  //       };
  //     } else {
  //
  //       return response.data;
  //     }
  //   } catch (error) {
  //     const axiosError = error as AxiosError;
  //     console.error("An error occurred:", axiosError);
  //     return {
  //       status: false,
  //       message: axiosError.response
  //         ? axiosError.response.data
  //         : "Unknown error",
  //     };
  //   }
  // },

  createAccountantBank: async (
    requestPayload: any,
  ): Promise<IAccountant | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<any> = await http.put<IAccountant>(
          `/v1/accountant-bank/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 404) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<any> = await http.post<IAccountant>(
        "/v1/accountant-bank/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 404) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getAccountantBankDataById: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IAccountant | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IAccountant> = await http.get<IAccountant>(
        `/v1/accountant-bank/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getGetAccountantDDL: async (): Promise<
    any | IServerError | IResponse | null
  > => {
    const response: AxiosResponse<any[]> =
      await http.get<any[]>(`/v1/accountants/ddl`);

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getAccountantBankList: async (
    accountantId: string | undefined,
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<any | IServerError | IResponse | null> => {
    if (!accountantId) return null;
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        "/v1/accountant-bank/?accountant_id=" +
          accountantId +
          "&order_by=" +
          data.order_by +
          "&order_direction=" +
          data.order_direction +
          "&page=" +
          data.page +
          "&size=" +
          data.size +
          "&search_query=" +
          data.search_query,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getGetAccountantBankDDL: async (
    accountantId: string,
  ): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<any[]> = await http.get<any[]>(
      `/v1/accountant-bank/ddl?accountant_id=${accountantId}`,
    );
    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
    // return [
    // 	{
    // 		"value": "484e763d-9217-4d69-b2d3-9c92d2940ae5",
    // 		"label": "Card One"
    // 	},
    // 	{
    // 		"value": "78b92a59-267a-4512-9e85-6f7bf169b89a",
    // 		"label": "Card Two"
    // 	},]
  },

  getClientsByAccountantId: async (
    accountantId: string,
    isAdminUser: number,
    params: IGetListRequest,
  ): Promise<IClientListPayload | IServerError | IResponse | any> => {
    if (accountantId !== "" && accountantId !== "0") {
      try {
        const response: AxiosResponse<IClientListPayload> =
          await http.get<IClientListPayload>(
            "/v1/clients/?accountant_id=" +
              accountantId +
              "&order_by=" +
              params.order_by +
              "&order_direction=" +
              params.order_direction +
              "&page=" +
              params.page +
              "&size=" +
              params.size +
              "&search_query=" +
              params.search_query,
          );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 400) {
          return {
            status: false,
            message: "Bad Request.",
            error: true,
          };
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        } else {
          return response.data;
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        return {
          status: false,
          message: axiosError.response
            ? axiosError.response.data
            : "Unknown error",
        };
      }

      // const fixedResponse: any = {
      // 	page: 1,
      // 	size: 50,
      // 	total: 1,
      // 	items: [
      // 		{
      // 			id: "779acde7-4966-4360-bb35-94f60ce90bbc",
      // 			clientName: "CANAMEX INC.",
      // 			operatingName: "CANAMEX",
      // 			email: "canamexInc.@hotmail.com",
      // 			province: "Ontario",
      // 			city: "Toronto",
      // 			country: "CAN",
      // 			postalCode: "A5S5S5",
      // 			phone1: "2223334444",
      // 			status: "Active",
      // 		},
      // 		{
      // 			id: "84eb7f21-d5ad-42d1-b9b2-4af1df3faf88",
      // 			clientName: "Decent Accounting",
      // 			operatingName: "Decent",
      // 			email: "DecentAccounting@hotmail.com",
      // 			province: "Quebec",
      // 			city: "Montreal",
      // 			country: "CAN",
      // 			postalCode: "W5E5R5",
      // 			phone1: "4567892222",
      // 			status: "Active",
      // 		},
      // 		{
      // 			id: "96f80b18-81e7-404f-bfe8-14437871b6a1",
      // 			clientName: "Websential Inc.",
      // 			operatingName: "Websential",
      // 			email: "WebsentialInc@gmail.com",
      // 			province: "Quebec",
      // 			city: "Montreal",
      // 			country: "CAN",
      // 			postalCode: "A5A6A7",
      // 			phone1: "1234569999",
      // 			status: "Active",
      // 		},
      // 	],
      // 	keyField: {
      // 		field: "name",
      // 		templateUrl: "/t4-slips/{id}",
      // 	},
      // 	headerColumns: [
      // 		{
      // 			field: "clientName",
      // 			headerName: "Client Name",
      // 			description: "",
      // 			flex: 1,
      // 			hide: false,
      // 			hideable: false,
      // 			sortable: true,
      // 			sortingOrder: "asc",
      // 			resizable: false,
      // 			type: "string",
      // 			align: "left",
      // 			headerAlign: "left",
      // 			hideSortIcons: false,
      // 			disableColumnMenu: true,
      // 			disableReorder: true,
      // 			disableExport: true,
      // 			maskable: false,
      // 			isFixed: true,
      // 			sequence: 0,
      // 			frozenColumn: false,
      // 			footer: null,
      // 		},
      // 		{
      // 			field: "operatingName",
      // 			headerName: "Operating Name",
      // 			description: "",
      // 			flex: 1,
      // 			hide: false,
      // 			hideable: false,
      // 			sortable: false,
      // 			sortingOrder: "asc",
      // 			resizable: false,
      // 			type: "string",
      // 			align: "left",
      // 			headerAlign: "left",
      // 			hideSortIcons: false,
      // 			disableColumnMenu: true,
      // 			disableReorder: true,
      // 			disableExport: true,
      // 			maskable: false,
      // 			isFixed: true,
      // 			sequence: 1,
      // 			frozenColumn: false,
      // 			footer: null,
      // 		},
      // 		{
      // 			field: "email",
      // 			headerName: "Email",
      // 			description: "",
      // 			flex: 1,
      // 			hide: false,
      // 			hideable: false,
      // 			sortable: false,
      // 			sortingOrder: "asc",
      // 			resizable: false,
      // 			type: "string",
      // 			align: "left",
      // 			headerAlign: "left",
      // 			hideSortIcons: false,
      // 			disableColumnMenu: true,
      // 			disableReorder: true,
      // 			disableExport: true,
      // 			maskable: false,
      // 			isFixed: true,
      // 			sequence: 3,
      // 			frozenColumn: false,
      // 			footer: null,
      // 		},
      // 		{
      // 			field: "phone1",
      // 			headerName: "Phone #",
      // 			description: "",
      // 			flex: 1,
      // 			hide: false,
      // 			hideable: false,
      // 			sortable: false,
      // 			sortingOrder: "asc",
      // 			resizable: false,
      // 			type: "string",
      // 			align: "left",
      // 			headerAlign: "left",
      // 			hideSortIcons: false,
      // 			disableColumnMenu: true,
      // 			disableReorder: true,
      // 			disableExport: true,
      // 			maskable: false,
      // 			isFixed: true,
      // 			sequence: 4,
      // 			frozenColumn: false,
      // 			footer: null,
      // 		},
      // 		{
      // 			field: "city",
      // 			headerName: "City",
      // 			description: "",
      // 			flex: 1,
      // 			hide: false,
      // 			hideable: false,
      // 			sortable: false,
      // 			sortingOrder: "asc",
      // 			resizable: false,
      // 			type: "string",
      // 			align: "left",
      // 			headerAlign: "left",
      // 			hideSortIcons: false,
      // 			disableColumnMenu: true,
      // 			disableReorder: true,
      // 			disableExport: true,
      // 			maskable: false,
      // 			isFixed: true,
      // 			sequence: 5,
      // 			frozenColumn: false,
      // 			footer: null,
      // 		},
      // 		{
      // 			field: "status",
      // 			headerName: "Status",
      // 			description: "",
      // 			flex: 1,
      // 			hide: false,
      // 			hideable: false,
      // 			sortable: false,
      // 			sortingOrder: "asc",
      // 			resizable: false,
      // 			type: "string",
      // 			align: "left",
      // 			headerAlign: "left",
      // 			hideSortIcons: false,
      // 			disableColumnMenu: true,
      // 			disableReorder: true,
      // 			disableExport: true,
      // 			maskable: false,
      // 			isFixed: true,
      // 			sequence: 6,
      // 			frozenColumn: false,
      // 			footer: null,
      // 		},
      // 	],
      // };

      // return new Promise((resolve) =>
      // 	setTimeout(() => resolve(fixedResponse), 1000)
      // );
    } else if ((isAdminUser !== 400 && accountantId === "") || "0") {
      try {
        const response: AxiosResponse<IClientListPayload> =
          await http.get<IClientListPayload>(
            `/v1/clients/full-client-list/by_user/?search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
          );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 400) {
          return {
            status: false,
            message: "Bad Request.",
            error: true,
          };
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        } else {
          return response.data;
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        return {
          status: false,
          message: axiosError.response
            ? axiosError.response.data
            : "Unknown error",
        };
      }
    } else {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }
  },

  getAccountantsDropDownList: async (): Promise<
    IDropDownListResponse[] | IServerError | IResponse | any
  > => {
    const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
      IDropDownListResponse[]
      // >("/v1/accountants/ddl");
    >("/v1/accountants/ddl/for-user-ddl/accountants");

    if (response.status === 200) {
      return response.data;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
    // return[
    //     { label: "Accountant 1", value: "1" },
    //     { label: "Accountant 2", value: "2" },
    //   ]
  },

  delBulkClients: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    const response = await http.delete<string>(`/v1/clients/`, {
      data: requestPayload.clientIds,
    });
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },

  moveClientsByAccountantId: async (
    requestPayload: any,
  ): Promise<IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IAccountant> = await http.post<IAccountant>(
        `/v1/clients/move_client/${requestPayload.accountantId}/`,
        requestPayload.clientIds,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 201) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      } else {
        return response.data;
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      return {
        status: false,
        message: axiosError.response
          ? axiosError.response.data
          : "Unknown error",
      };
    }
  },
  archiveAccountantBanks: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/accountant-bank/${archivePayload.departmentsId}/`,
      );

      if (response.status === 201) {
        return "Accountant Bank has been archived successfully";
      } else if (response.status === 200) {
        return "Accountant Bank has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getAccountantsToManageNavBar: async (
    data: IGetListRequest,
    isAdminUser: number,
    selectedAccountantId: string,
  ): Promise<
    | IAccountantListPayload
    | IServerError
    | IResponse
    | IAccountantResponse[]
    | null
  > => {
    if (isAdminUser === 400) {
      return null;
    } else if (selectedAccountantId && selectedAccountantId.length > 0) {
      try {
        const response: AxiosResponse<IAccountantListPayload> =
          await http.get<IAccountantListPayload>(
            "/v1/accountants/?order_by=" +
              data.order_by +
              "&order_direction=" +
              data.order_direction +
              "&page=" +
              data.page +
              "&size=" +
              data.size +
              "&search_query=" +
              data.search_query,
          );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 400) {
          return {
            status: false,
            message: "Bad Request.",
            error: true,
          };
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        return { status: false, message: errorMessage, error: true };
      }
    } else {
      return null;
    }
  },
  getAccountantBankDetailsForPAD: async (
    accountantId: string,
    screenType: number,
  ): Promise<IAccountant | IServerError | IResponse | null | any> => {
    if (!accountantId) return null;
    try {
      const response: AxiosResponse<IAccountant> = await http.get<IAccountant>(
        `/v1/accountant-bank/${accountantId}/pad/?parent_screen=${screenType}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
};
